const prepositions = ['на', 'и', 'под'];

/**
 * Добавляет неразрывный пробел между предлогом и следующим словом
 * требование к UI, чтоб строка не обрывалась после предлога
 */

const nbspPreposition = (s: string | null): string => {
  if (!s) return '';

  const words = s.split(' ');
  let resultString = '';
  for (const word of words) {
    const isJoinWithNBSP = prepositions.includes(word);
    resultString = resultString + word + (isJoinWithNBSP ? '&nbsp;' : ' ');
  }
  return resultString.trim();
};

export default nbspPreposition;
